import { Annotation } from "../utils/types";

const getListDocs = async () => {
  try {
    const response = await fetch(
      "https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/list/doc",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("unable to fetch the docs");
    }
  } catch (error) {
    throw new Error("unable to fetch the docs");
  }
};

const uploadPDF = async (selectedFile: File) => {
  const formData = new FormData();

  formData.append("file", selectedFile);
  formData.append("mode", "bern2");

  try {
    const response = await fetch(
      "https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/submit/doc",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json(); // Parse JSON response
    return result;
  } catch (error) {
    throw new Error("unable to upload the docs");
  }
};

const getDocStatus = async (id: string) => {
  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/status/doc/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("unable to fetch the status");
    }
  } catch (error) {
    throw new Error("unable to fetch the status");
  }
};

const getEntity = async (id: string) => {
  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/entity/${id}/latest`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("unable to fetch the status");
    }
  } catch (error) {
    throw new Error("Something went wrong while fetching the entity");
  }
};

const updateEntity = async (
  id: string,
  version: number,
  data: Annotation[]
) => {
  try {
    const payload = {
      document_id: id,
      version,
      entities: data,
    };
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/entity/${id}/${version}`,
      {
        method: "PUT",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("failed update the entity");
    }
  } catch (error) {
    throw new Error("something went wrong while updating the entity");
  }
};

const softDelete = async (id: string) => {
  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/doc/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      return response;
    } else {
      throw new Error("failed to delete the document");
    }
  } catch (error) {
    throw new Error("Unable to delete the document");
  }
};

const hardDelete = async (id: string) => {
  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/doc/${id}/hard`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      return response;
    } else {
      throw new Error("failed to delete the document");
    }
  } catch (error) {
    throw new Error("Unable to delete the document");
  }
};

const startScraping = async (id: string) => {
  const dataToSend = {
    country: "US",
    status: "active",
  };

  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/start/scraping/${id}/latest`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );
    if (response && response.ok) {
      return response;
    } else {
      throw new Error("failed start the scraping");
    }
  } catch (error) {
    throw new Error("Unable to start the scraping");
  }
};

// New function for patent office selection with customizable countries
const startScrapingWithCountries = async (id: string, countries: string) => {
  const dataToSend = {
    country: countries,
    status: "active",
  };

  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/start/scraping/${id}/latest`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Failed to start scraping: ${response.status} ${errorText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API Error:", error);
    throw new Error(
      error instanceof Error ? error.message : "Unable to start the scraping"
    );
  }
};

const ftoGeneration = async (id: string) => {
  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/generate/fto/${id}/latest`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      return response;
    } else {
      throw new Error("failed to generate fto");
    }
  } catch (error) {
    throw new Error("Unable to generate fto");
  }
};

const getFtoReport = async (id: string) => {
  try {
    const response = await fetch(
      `https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/fto/${id}/latest`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response && response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("unable to download FTO report");
    }
  } catch (error) {
    throw new Error("Unable to generate fto");
  }
};

export {
  getListDocs,
  uploadPDF,
  getDocStatus,
  getEntity,
  updateEntity,
  softDelete,
  hardDelete,
  startScraping,
  startScrapingWithCountries,
  ftoGeneration,
  getFtoReport,
};
